import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SelectDialogData } from '../../../model/select-dialog.model';

@Component({
  selector: 'select-dialog',
  templateUrl: './select-dialog.component.html',
  styleUrls: []
})
export class SelectDialogComponent {

  form: FormGroup = this.formBuilder.group({
    select: ['', Validators.required],
  });

  constructor(
    public dialogRef: MatDialogRef<SelectDialogComponent>,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: SelectDialogData,
  ) {
  }

  onSubmit() {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value.select)
    }
  }
}
